import { createRouter, createWebHistory } from 'vue-router'
import { store } from './store'
import LoginView from './views/LoginView.vue'
import DashboardView from './views/DashboardView.vue'
import SubjectsView from './views/SubjectsView.vue'
import SubjectView from './views/SubjectView.vue'
import LessonView from './views/LessonView.vue'
import QuizView from './views/QuizView.vue'
import ProgressView from './views/ProgressView.vue'
import VocabularyView from './views/VocabularyView.vue'
import ParentView from './views/ParentView.vue'
import AdminView from './views/AdminView.vue'
import AdminContentView from './views/AdminContentView.vue'
import AdminTransferView from './views/AdminTransferView.vue'
import UsersView from './views/UsersView.vue'
import ProfileView from './views/ProfileView.vue'
import NotFoundView from './views/NotFoundView.vue'

const routes = [
  { path: '/login', component: LoginView, meta: { public: true, title: 'Đăng nhập' } },
  { path: '/', component: DashboardView, meta: { roles: ['student'], title: 'Hôm nay' } },
  { path: '/mon-hoc', component: SubjectsView, meta: { roles: ['student', 'parent', 'admin'], title: 'Môn học' } },
  { path: '/mon-hoc/:slug', component: SubjectView, meta: { roles: ['student', 'parent', 'admin'], title: 'Chương trình' } },
  { path: '/bai-hoc/:id', component: LessonView, meta: { roles: ['student', 'admin'], title: 'Bài học' } },
  { path: '/luyen-tap/:id', component: QuizView, meta: { roles: ['student'], title: 'Luyện tập' } },
  { path: '/tien-do', component: ProgressView, meta: { roles: ['student'], title: 'Tiến độ' } },
  { path: '/tu-vung', component: VocabularyView, meta: { roles: ['student'], title: 'Kho từ vựng' } },
  { path: '/phu-huynh', component: ParentView, meta: { roles: ['parent'], title: 'Báo cáo học tập' } },
  { path: '/quan-tri', component: AdminView, meta: { roles: ['admin'], title: 'Tổng quan quản trị' } },
  { path: '/quan-tri/noi-dung', component: AdminContentView, meta: { roles: ['admin'], title: 'Soạn nội dung' } },
  { path: '/quan-tri/nhap-xuat', component: AdminTransferView, meta: { roles: ['admin'], title: 'Nhập / xuất học liệu' } },
  { path: '/quan-tri/tai-khoan', component: UsersView, meta: { roles: ['admin'], title: 'Học sinh & tài khoản' } },
  { path: '/ho-so', component: ProfileView, meta: { roles: ['student', 'parent', 'admin'], title: 'Hồ sơ cá nhân' } },
  { path: '/:pathMatch(.*)*', component: NotFoundView, meta: { title: 'Không tìm thấy' } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  if (!store.ready) await store.loadUser()
  document.title = `${to.meta.title || 'VuiHoc'} — VuiHoc`
  if (to.meta.public) {
    if (to.path === '/login' && store.user) {
      return store.user.role === 'parent' ? '/phu-huynh' : store.user.role === 'admin' ? '/quan-tri' : '/'
    }
    return true
  }
  if (!store.user) return { path: '/login', query: { next: to.fullPath } }
  if (to.meta.roles && !to.meta.roles.includes(store.user.role)) {
    return store.user.role === 'parent' ? '/phu-huynh' : store.user.role === 'admin' ? '/quan-tri' : '/'
  }
  return true
})

export default router
